import styled from 'styled-components';
import { ReactComponent as RawMobileSmallSVG } from '../../../../assets/icons/icon_mobile_small.svg';

export const IconMobileSmall = styled(RawMobileSmallSVG)``;
